import gql from 'graphql-tag'

export const HOME_QUERY = gql`
query {
  home {
    data {
      id
      attributes {
        Intro {
          Intro {
            id
            Title
            Description
            Caption
          }
          Button {
            id
            href
            label
            isExternal
          }
        }
        Services {
          id
          Intro {
            Title
            Description
            Caption
          }
          Button {
            id
            href
            label
            isExternal
          }
          Accortions {
            id
            Title
            Content
          }
        }
        OurClients {
          Intro {
            id
            Title
            Description
            Caption
          }
          Clients {
            Name
            Info
            Image {
              data {
                attributes {
                  url
                  alternativeText
                  formats
                }
              }
            }
          }
        }
        SelectedWork {
          Intro {
            Title
            Description
            Caption
          }
          Image1 {
            data {
              attributes {
                url
                alternativeText
                formats
              }
            }
          }
          Image2 {
            data {
              attributes {
                url
                alternativeText
                formats
              }
            }
          }
          Button {
            href
            label
            isExternal
          }
          case_studies {
            data {
              id
              attributes {
                Title
                caption
                slug
                FeaturedImage {
                  data {
                    attributes {
                      url
                      alternativeText
                      formats
                    }
                  }
                }
              }
            }
          }
        }
        GetInTouch {
          Intro {
            Title
            Description
            Caption
          }
        }
        Seo {
          metaTitle
          metaDescription
          metaImage {
            data {
              attributes {
                url
                alternativeText
                formats
              }
            }
          }
          metaSocial {
            socialNetwork
            title
            description
            image {
              data {
                attributes {
                  url
                  alternativeText
                  formats
                }
              }
            }
          }
        }
      }
    }
  }
}
`;
